import React from 'react';
import * as routes from 'app/routes';
import Back from 'common/Back';
import qs from 'qs'

import SelectedPlan from 'insurance/insurancePlans/SelectedPlan';
import DeviceInfo from 'devices/DeviceInfo';

const InsuranceConfirm = ({ subId, sku, insPlanId, ConfirmInsurance, insurancePlanRoute }) => {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  return (
    <div>
      <Back to={insurancePlanRoute(subId, sku, query.deviceId)} />
      <h1>
        Your Device Protection Details
      </h1>
      <SelectedPlan insurancePlanId={insPlanId} />
      <DeviceInfo deviceId={sku} />
      <ConfirmInsurance insurancePlanId={insPlanId} sku={sku} subId={subId} deviceId={query.deviceId} />
    </div>
  )
}

export default InsuranceConfirm;
